module.exports = __webpack_public_path__ + "img/palestine-ar.3ddcf803.png";